import classNames from 'classnames'
import { useOnce } from '@opallabs/lambda'
import { singleSelectClasses } from '../componentClassNames'
import { useSingleSelectState } from '../contexts'
import * as styles from './styles'

export const MenuFooter: React.FC<
  React.PropsWithChildren<{ className?: string }>
> = ({ children, className }) => {
  const { closeMenu, setHasFooter, toggleRef } = useSingleSelectState()

  const onBlur = () => {
    closeMenu()
    toggleRef.current?.focus()
  }

  useOnce(() => setHasFooter(true))

  return (
    <div
      className={classNames(singleSelectClasses.footer, className)}
      css={styles.footer}
      onBlur={onBlur}
    >
      {children}
    </div>
  )
}
MenuFooter.displayName = 'Lapidary: MenuFooter ← SingleSelect'
